<template>
  <div id="construcMe" v-show="dialogVisibleForm">
    <el-dialog v-dialogDrag  :visible.sync="dialogVisibleForm" title="选择构件" append-to-body
      :close-on-click-modal="false" :close-on-press-escape="false" width="600px" class="dialogMe">
      <el-tree ref="tree" :expand-on-click-node="false" class="navTree" :data="datatree" :props="defaultProps"
      :default-expand-all="true" highlight-current show-checkbox node-key="folderId" :check-strictly="true"
       @check="currentOrgChangeHandler">
        <template #default="{ data }">
          <div class="treeContent">
            <span class="name" :title="data.folderName">{{data.folderName}}</span>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelHanderForm" size="small">取 消</el-button>
        <el-button  type="primary" @click="addHander()" size="small">确 定</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import quaService from "@/xgzdService/quaMange-service"
import { mapState } from "vuex"
export default {
  data(){
    return{
      dialogVisibleForm:false,
      updateKey:0,
      datatree:[],
      defaultProps:{
        children: "childList",
        label: "label",
      },
      selectData:[],
      checkedNodes:[]
    }
  },
  computed:{
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo,
    }),
  },
  methods:{
    open(){
      this.dialogVisibleForm=true;
      this.updateKey++;
      this.getTree()
    },
    cancelHanderForm(){
      this.dialogVisibleForm=false;
    },
    async getTree(){
      const {fileIds }=this.$route.query;
      const params=fileIds.split(",")
      const {data} =await quaService.getSelectSetFolderTree(params);
       this.datatree=await this.formatData(data);
    },
     //将所有选择框去掉
    formatData(params){
      let data = params;
      data.map((item) => {
        if(item.folderType=="1"&&!item.modelId)item.disabled = false;
        else item.disabled = true;
        if(item.childList&&item.childList.length>0)this.formatData(item.childList)
      });
      return data;
    },
    async currentOrgChangeHandler(val, currentChecked) {
      this.selectData=[];
      this.checkedNodes=[];
      this.checkedNodes=currentChecked.checkedNodes;
      // 把源数据先变成目标数据的规则
      var oldDataRule = []
      this.checkedNodes.forEach(el => {
        var oldObj = {
          modelId: el.parentId?.substring(el.parentId.length-16),
          componentList: []
        }
        var obj = {
          componentId: el.folderId,
          componentName: el.folderName
        }
        oldObj.componentList.push(obj)
        oldDataRule.push(oldObj)
      })
       /**
       * 先去重，后合并
       * 1、源数据去重
       * 2、把去重后的数据和源数据中相同modelId的数据合并componentList
      */
      var newData = []
      var newObj = {}
      oldDataRule.forEach((el, i) => {
        if (!newObj[el.modelId]) {
          newData.push(el)
          newObj[el.modelId] = true
        } else {
          newData.forEach(el => {
            if (el.modelId === oldDataRule[i].modelId) {
              el.componentList = el.componentList.concat(oldDataRule[i].componentList)
            }
          })
        }
      })
      this.selectData=newData;
    },
    async addHander(){
      this.$emit("addHander",this.selectData)
      this.dialogVisibleForm=false;
    },
  }
}
</script>

<style lang="scss">
.dialogMe{
  .el-dialog__title{
    font-size: 16px;
    color: #323232;
  }
  .el-dialog__body{
    background: #F4F5FA;
    height: 350px;
    padding:11px 16px 0 16px !important
  }
  .navTree{
    height: 100%;
    width: 100%;
    overflow: auto;
  }
  .el-checkbox__input.is-disabled .el-checkbox__inner{
    display :none;
  }
}

</style>
